import { render } from "./navigation-item.vue?vue&type=template&id=c2587630&scoped=true"
import script from "./navigation-item.vue?vue&type=script&lang=js"
export * from "./navigation-item.vue?vue&type=script&lang=js"

import "./navigation-item.vue?vue&type=style&index=0&id=c2587630&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2587630"]])

export default __exports__